import GenericInformation from "./GenericInformation";
import {connect} from "react-redux";
import { getGenericInfo } from "../../redux/actions/genericInformation/genericInformation.action";
import { getBroadCastNotificationList } from "../../redux/actions/notification/getBroadCastNotificationList.action";

const mapStateToProps = (state) => {
    return {
            pops:state.genericInformation.data,
            loadingPOPs:state.genericInformation.isLoading,
            myRights:state.myRights.myRights,
            broadCastnotification:state.notifications.broadcastNotification

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getGenericInfo: (tadigID) => {
            return dispatch(getGenericInfo(tadigID))
        },
        getBroadCastNotificationList: (id) => {
            return dispatch(getBroadCastNotificationList(id))
          }, 
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(GenericInformation);
